import { TrustBadge } from "./TrustBadge";

/** Subtle “Worthy Human” badge mark for Supporter / Team curators (spec: corner gold mark). */
export function WorthyHumanBadge({ className = "" }: { className?: string }) {
	return (
		<TrustBadge
			className={className}
			title="Worthy Human — thank you for supporting WorthyIdea"
		/>
	);
}
